import React, { useEffect, useState } from 'react';
import Card from '../components/ui/Card';
import Badge from '../components/ui/Badge';
import { dashboardApi } from '../api/dashboard';
import { COLORS } from '../theme';
import { useTituloPagina } from '../context/PageTitleContext';

function formatarReais(v) {
  return (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

function CardKpi({ titulo, valor, quantidade, tom = 'neutro' }) {
  const cores = {
    neutro: { bg: COLORS.bg, texto: COLORS.text, rotulo: COLORS.textLight },
    primary: { bg: COLORS.primaryBg, texto: COLORS.primary, rotulo: COLORS.primary },
    aviso: { bg: COLORS.warningBg, texto: COLORS.warning, rotulo: COLORS.warning },
    perigo: { bg: COLORS.dangerBg, texto: COLORS.danger, rotulo: COLORS.danger }
  };
  const c = cores[tom];
  return (
    <div style={{ background: c.bg, borderRadius: 10, padding: 16, flex: 1, minWidth: 180 }}>
      <div style={{ fontSize: 11, color: c.rotulo, textTransform: 'uppercase', fontWeight: 700 }}>{titulo}</div>
      <div style={{ fontSize: 24, fontWeight: 700, color: c.texto, marginTop: 4 }}>{valor}</div>
      {quantidade !== undefined && <div style={{ fontSize: 12, color: c.rotulo, marginTop: 2 }}>{quantidade} lançamento{quantidade === 1 ? '' : 's'}</div>}
    </div>
  );
}

export default function Dashboard() {
  useTituloPagina('Início');
  const [dados, setDados] = useState(null);

  useEffect(() => { dashboardApi.obter().then(setDados).catch(() => {}); }, []);

  if (!dados) return null;

  return (
    <div>
      <Card style={{ marginBottom: 14 }}>
        <strong style={{ fontSize: 13, display: 'block', marginBottom: 12 }}>Vendas do Mês</strong>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <CardKpi titulo="Total Vendido" valor={formatarReais(dados.vendas_mes.total)} quantidade={dados.vendas_mes.quantidade} tom="primary" />
        </div>
      </Card>

      <Card style={{ marginBottom: 14 }}>
        <strong style={{ fontSize: 13, display: 'block', marginBottom: 12 }}>Contas a Pagar</strong>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <CardKpi titulo="Vencendo em 7 dias" valor={formatarReais(dados.contas_pagar.vencendo.total)} quantidade={dados.contas_pagar.vencendo.quantidade} tom="aviso" />
          <CardKpi titulo="Atrasadas" valor={formatarReais(dados.contas_pagar.atrasadas.total)} quantidade={dados.contas_pagar.atrasadas.quantidade} tom="perigo" />
        </div>
      </Card>

      <Card style={{ marginBottom: 14 }}>
        <strong style={{ fontSize: 13, display: 'block', marginBottom: 12 }}>Contas a Receber</strong>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <CardKpi titulo="Vencendo em 7 dias" valor={formatarReais(dados.contas_receber.vencendo.total)} quantidade={dados.contas_receber.vencendo.quantidade} tom="aviso" />
          <CardKpi titulo="Atrasadas" valor={formatarReais(dados.contas_receber.atrasadas.total)} quantidade={dados.contas_receber.atrasadas.quantidade} tom="perigo" />
        </div>
      </Card>

      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <strong style={{ fontSize: 13 }}>Produtos com Estoque Baixo</strong>
          <Badge tom={dados.estoque_baixo.quantidade > 0 ? 'perigo' : 'sucesso'}>{dados.estoque_baixo.quantidade} produto{dados.estoque_baixo.quantidade === 1 ? '' : 's'}</Badge>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>Código</th>
              <th style={{ padding: 10 }}>Produto</th>
              <th style={{ padding: 10 }}>Estoque Atual</th>
              <th style={{ padding: 10 }}>Estoque Mínimo</th>
            </tr>
          </thead>
          <tbody>
            {dados.estoque_baixo.itens.map(item => (
              <tr key={item.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                <td style={{ padding: 10 }}>{item.codigo}</td>
                <td style={{ padding: 10 }}>{item.nome}</td>
                <td style={{ padding: 10, color: COLORS.danger, fontWeight: 700 }}>{Number(item.estoque_atual)}</td>
                <td style={{ padding: 10 }}>{Number(item.estoque_minimo)}</td>
              </tr>
            ))}
            {dados.estoque_baixo.itens.length === 0 && (
              <tr><td colSpan={4} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhum produto com estoque abaixo do mínimo.</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
